<template>
  <AppSidebar
    :visible="visible"
    @close="close"
  >
    <ReportSavedReportFilterDialog
      :show="showSavedReportFilterDialog"
      :saved-report-filter="currentSavedReportFilter"
      @close="closeSavedReportFilterDialog"
    />
    <AppTabs
      compact
      @change="onSelectedTab"
    >
      <AppTab label="Filters">
        <slot></slot>
        <div class="mt-auto">
          <div v-if="showScheduledReportButton">
            <AppButton
              type="info"
              block
              @click="toggleScheduledReportDialog"
            >
              Schedule report
            </AppButton>
            <AppButton
              type="outline"
              block
              @click="showNewSavedReportFilterDialog"
            >
              Save filters
            </AppButton>
            <AppButton
              block
              @click="clearFilters"
            >
              Clear filters
            </AppButton>
          </div>
          <div v-else>
            <AppButton
              block
              @click="clearFilters"
            >
              Clear filters
            </AppButton>
            <AppButton
              type="outline"
              block
              @click="showNewSavedReportFilterDialog"
            >
              Save filters
            </AppButton>
          </div>
        </div>
      </AppTab>
      <AppTab
        label="Saved Filters"
        :selected="selectedTab === 'savedFilters'"
      >
        <ReportSavedFilterList @edit="showEditSavedReportFilterDialog" />
      </AppTab>
    </AppTabs>
  </AppSidebar>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import select2DropdownParentMixin from '~/mixins/Select2DropdownParent';

export default {
  mixins: [select2DropdownParentMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showScheduledReportButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentSavedReportFilter: null,
      showSavedReportFilterDialog: false,
      selectedTab: 'filters',
    };
  },
  computed: {
    ...mapState(['saved_report_filters', 'report_name']),
  },
  watch: {
    visible(newVisible) {
      newVisible && this.analyticsTrack('Filters sidebar opened');

      newVisible ? document.body.classList.add('filters-opened') : document.body.classList.remove('filters-opened');
    },
  },
  methods: {
    ...mapActions(['analyticsTrackReport']),
    toggleScheduledReportDialog() {
      this.$emit('open-dialog', 'scheduledReport');
    },
    close() {
      this.$emit('close');
    },
    clearFilters() {
      this.$emit('clear-filters');
    },
    showNewSavedReportFilterDialog() {
      this.currentSavedReportFilter = null;
      this.showSavedReportFilterDialog = true;
    },
    showEditSavedReportFilterDialog(savedReportFilter) {
      this.currentSavedReportFilter = savedReportFilter;
      this.showSavedReportFilterDialog = true;
    },
    closeSavedReportFilterDialog() {
      this.showSavedReportFilterDialog = false;
    },
    onSelectedTab(tab) {
      tab === 'savedFilters' && this.analyticsTrack('Filters saved tab opened');
    },
    analyticsTrack(eventName) {
      this.analyticsTrackReport({
        event: eventName,
        props: {
          saved_filters: this.saved_report_filters.length,
        },
      });
    },
  },
};
</script>
